import { Component, computed, inject, Input, signal, ChangeDetectionStrategy } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { SAMPLE_MONTH } from '../energy-balance-data';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MonthlyBalanceChartComponent } from './monthly-balance-chart.component';

import { environment } from '../../../../../environments/environment';
import { Api } from '../../../../../api/api';
import { getEnergyBalances } from '../../../../../api/functions';
import { LocationStateService } from '../../../../../common/services/location-state.service';
import { from } from 'rxjs';

@Component({
  selector: 'app-monthly-energy-balance',
  templateUrl: './monthly-balance.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatInputModule, MatFormFieldModule, MatDatepickerModule, MonthlyBalanceChartComponent],
})
export class MonthlyBalanceComponent {
  api = inject(Api);
  startDate = signal(new Date());
  endDate = signal(new Date());
  locationStateService = inject(LocationStateService);

  @Input()
  set date(value: Date) {
    this.startDate.set(new Date(value.getFullYear(), value.getMonth(), 1));
    this.endDate.set(new Date(value.getFullYear(), value.getMonth() + 1, 0, 23, 59, 59));
  }

  params = computed(() => ({
    location_id: this.locationStateService.currentLocation()?.id ?? '',
    aggregation: 'month',
    from: this.startDate().toISOString(),
    to: this.endDate().toISOString(),
  }));

  resource = rxResource({
    params: this.params,
    defaultValue: environment.showDefault ? SAMPLE_MONTH : undefined,
    stream: (loaderParams) => from(this.api.invoke(getEnergyBalances, loaderParams.params)),
  });

  data = computed(() => (this.resource.hasValue() ? this.resource.value() : []));
}
